import axios from 'axios';
import type { APIResponse, RetrieveAllParams } from '~/api/utils';
import { type ComicBookCover } from '~/types/ComicBook';

const API_URL = '/comic-book/cover';

class CoverService {
    async createComicBookCover(cover: ComicBookCover): Promise<ComicBookCover> {
        const response = await axios.post<ComicBookCover>(API_URL, cover);
        return response.data;
    }

    async getComicBookCoverById(id: string): Promise<ComicBookCover> {
        const response = await axios.get<ComicBookCover>(`${API_URL}/${id}`);
        return response.data;
    }

    async updateComicBookCover(id: string, updatedComicBookCover: Partial<ComicBookCover>): Promise<ComicBookCover> {
        const response = await axios.put<ComicBookCover>(`${API_URL}/${id}`, updatedComicBookCover);
        return response.data;
    }

    async deleteComicBookCover(id: string): Promise<void> {
        return await axios.delete(`${API_URL}/${id}`);
    }

    async retrieveAllComicBookCovers(params?: RetrieveAllParams): Promise<APIResponse<ComicBookCover>> {
        const response = await axios.get(`${API_URL}`, {
            params: {
                ...params,
            },
        });
        return response.data;
    }
}

export default new CoverService();
